import { HearkenStatus } from 'types/hearkenStatus'
import * as React from 'react'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'

/**
 * Displays a (DataWrapper) chart
 * @param hearkenStatus
 * @param investigatingChartUrl
 * @constructor
 */
export function VoteChart({
  hearkenStatus,
  investigatingChartUrl
}: {
  hearkenStatus: HearkenStatus
  investigatingChartUrl?: string
}) {
  if (hearkenStatus !== HearkenStatus.INVESTIGATING || !investigatingChartUrl) {
    return null
  }

  return (
    <AutofitIFrame title='Abstimmungsergebnisse' src={investigatingChartUrl} />
  )
}
